import axios from "axios";
export const viagemIntermunicipalApi = (token) => axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/viagem-intermunicipal`,
    headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: token ? `Bearer ${token}` : undefined,
        "app-key": process.env.REACT_APP_APP_KEY || "",
    },
});
